import { FWPauseAdCustomParams } from 'tag/ts/tag/model/ads/pause/FWPauseAdCustomParams';
import { FWPauseAdGlobalParams } from 'tag/ts/tag/model/ads/pause/FWPauseAdGlobalParams';
import { FWPauseAdSiteParams } from 'tag/ts/tag/model/ads/pause/FWPauseAdSiteParams';
import { FWPauseAdSlotParams } from 'tag/ts/tag/model/ads/pause/FWPauseAdSlotParams';
import { FWPauseAdSTVParams } from 'tag/ts/tag/model/ads/pause/FWPauseAdSTVParams';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class FreeWheelPauseAdModel {
    #name;
    #globalParams;
    #mergedParams;
    #slotParams;
    #params;
    #tag;
    constructor(argument) {
        argument.name = 'FreeWheelPauseAdModel';
        this.#tag = argument?.tag;
        this.#name = argument?.name;
        const adSetupInfo = this.#tag?.model?.adUtilities?.adSetupInfo();
        switch (argument?.embedType) {
            case EmbedType.DESKTOP:
                const siteParams = new FWPauseAdSiteParams({ tag: this.#tag });
                const customParams = new FWPauseAdCustomParams({ tag: this.#tag });
                this.#globalParams = new FWPauseAdGlobalParams({ tag: this.#tag });
                this.#mergedParams = {
                    ...(siteParams.adParameters || {}),
                    ...(customParams.adParameters || {})
                };
                this.#slotParams = new FWPauseAdSlotParams(EmbedType.DESKTOP);
                break;
            case EmbedType.HTML5:
                const stvParams = new FWPauseAdSTVParams(this.#tag);
                this.#globalParams = new FWPauseAdGlobalParams({ tag: this.#tag, paramsOverride: stvParams.paramsOverride });
                this.#mergedParams = {
                    ...(stvParams.params || {})
                };
                this.#slotParams = new FWPauseAdSlotParams(EmbedType.HTML5);
                break;
        }
        this.#params = {
            ...(this.#globalParams.adParameters || {}),
            ...(this.#mergedParams || {}),
            ...(this.#slotParams.params || {})
        };
    }
    get name() {
        return this.#name;
    }
    get globalParams() {
        return this.#globalParams.adParameters;
    }
    get mergedParams() {
        return this.#mergedParams;
    }
    get slotParams() {
        return this.#slotParams.params;
    }
    get params() {
        return this.#params;
    }
}
